import { render, staticRenderFns } from "./RouterLink.vue?vue&type=template&id=2de01099&functional=true&"
import script from "./RouterLink.vue?vue&type=script&lang=js&"
export * from "./RouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports